export const NODE_NAME = 'table_header';
